module.exports = __webpack_public_path__ + "img/layanan-surety.72b4cc50.webp";